// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as publicIndexRouteImport } from './routes/(public)/index'
import { Route as publicNewsletterIndexRouteImport } from './routes/(public)/newsletter/index'
import { Route as publicPrivacyIndexRouteImport } from './routes/(public)/privacy/index'
import { Route as publicTermsIndexRouteImport } from './routes/(public)/terms/index'
import { Route as publicNewsletterReleaseIdIndexRouteImport } from './routes/(public)/newsletter/$releaseId/index'
import { Route as publicNewsletterUnsubscribeIndexRouteImport } from './routes/(public)/newsletter/unsubscribe/index'

const publicIndexRoute = publicIndexRouteImport.update({
            id: '/(public)/',path: '/',getParentRoute: () => rootRouteImport
          })
const publicNewsletterIndexRoute = publicNewsletterIndexRouteImport.update({
            id: '/(public)/newsletter/',path: '/newsletter/',getParentRoute: () => rootRouteImport
          })
const publicPrivacyIndexRoute = publicPrivacyIndexRouteImport.update({
            id: '/(public)/privacy/',path: '/privacy/',getParentRoute: () => rootRouteImport
          })
const publicTermsIndexRoute = publicTermsIndexRouteImport.update({
            id: '/(public)/terms/',path: '/terms/',getParentRoute: () => rootRouteImport
          })
const publicNewsletterReleaseIdIndexRoute = publicNewsletterReleaseIdIndexRouteImport.update({
            id: '/(public)/newsletter/$releaseId/',path: '/newsletter/$releaseId/',getParentRoute: () => rootRouteImport
          })
const publicNewsletterUnsubscribeIndexRoute = publicNewsletterUnsubscribeIndexRouteImport.update({
            id: '/(public)/newsletter/unsubscribe/',path: '/newsletter/unsubscribe/',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  publicIndexRoute: publicIndexRoute,publicNewsletterIndexRoute: publicNewsletterIndexRoute,publicPrivacyIndexRoute: publicPrivacyIndexRoute,publicTermsIndexRoute: publicTermsIndexRoute,publicNewsletterReleaseIdIndexRoute: publicNewsletterReleaseIdIndexRoute,publicNewsletterUnsubscribeIndexRoute: publicNewsletterUnsubscribeIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)